import store from '@state/store'
import popup from './popup'
import axios from 'axios'

var instance = axios.create()

instance.defaults.timeout = 30000
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded;charset=UTF-8'

instance.interceptors.request.use(
  (config) => {
    if (
      config &&
      config.params &&
      config.params.customConfig &&
      config.params.customConfig.withoutLoading
    ) {
      delete config.params.customConfig
    } else {
      // store.dispatch('layout/startLoading')
    }
    return config
  },
  (e) => {
    // store.dispatch('layout/startLoading')
    return Promise.error(e)
  }
)

instance.interceptors.response.use(
  (response) => {
    if (response.status === 200 && response.data.status_code === '00') {
      // store.dispatch('layout/endLoading')
      return Promise.resolve(response)
    } else {
      store.dispatch('layout/endLoading')
      popup({ text: 'システムエラーが発生しました。(WU99995)' })
      return Promise.reject(response)
    }
  },
  (e) => {
    store.dispatch('layout/endLoading')
    // if (e.response.status) {
    //   switch (e.response.status) {
    //     case 1000:
    //       popup({ text: 'ログインを行ってください。' })
    //       throw new Error('セッションエラー')
    //     case 2000:
    //       popup({ text: 'システム停止中です。' })
    //       throw new Error('システム停止モード時')
    //     case 2001:
    //       popup({ text: 'システムメンテナンス中です。' })
    //       throw new Error('システムメンテナンスモード時')
    //     case 2101:
    //       popup({ text: 'ログイン権限がありません。' })
    //       throw new Error('ログイン権限対象外')
    //     case 2102:
    //       popup({ text: 'JAF会員番号をお確かめください。' })
    //       throw new Error('会員照会失敗')
    //     case 2120:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('外部サーバ接続失敗')
    //     case 3000:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('DBコネクションエラー')
    //     case 3001:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('システムエラー')
    //     case 3002:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('コンストラクタ内のエラー')
    //     case 3003:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SYS_COM_CD取得エラー')
    //     case 3123:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('施設取得エラー')
    //     case 3146:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('訪問履歴エラー')
    //     case 3147:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('お得満足情報エラー')
    //     case 3221:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('クーポンエラー・施設グループ情報エラー')
    //     case 3311:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error(
    //         'クーポンテーブル登録更新エラー・クーポンプレビューテーブル登録更新エラー・クーポン使用ログ登録エラー・クーポン表示ログ登録エラー'
    //       )
    //     case 3150:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('会員情報取得エラー')
    //     case 3151:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('検索履歴取得エラー')
    //     case 3161:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('登録更新エラー')
    //     case 2155:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('アカウント作成エラー')
    //     case 5000:
    //       popup({ text: 'ログインを行ってください。' })
    //       throw new Error(
    //         'ログイン時汎用エラー・SSOセッションなし・有効期限切れ時'
    //       )
    //     case 5200:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('基本的に発生しない(SSOサーバ側接続不能時）')
    //     case 5201:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSOセッション確認API実行結果：プロトコル不正エラー')
    //     case 5202:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSOセッション確認API実行結果：パラメータ不正エラー')
    //     case 5203:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSOセッション確認API実行結果：サービスID指定エラー')
    //     case 5204:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSOセッション確認API実行結果：システムエラー')
    //     case 5205:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSOセッション確認API実行結果：会員有効性確認エラー')
    //     case 5250:
    //       popup({ text: 'ログインを行ってください。' })
    //       throw new Error('セッションIDが空の時')
    //     case 5251:
    //       popup({ text: 'ログインを行ってください。' })
    //       throw new Error('SSO未ログインのセッションIDの時')
    //     case 5300:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('基本的に発生しない(SSOサーバ側接続不能時）')
    //     case 5301:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSO会員情報取得API実行結果：プロトコル不正エラー')
    //     case 5302:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSO会員情報取得API実行結果：パラメータ不正エラー')
    //     case 5303:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSO会員情報取得API実行結果：サービスID指定エラー')
    //     case 5304:
    //       popup({ text: '時間をおいて、再度ご利用ください。' })
    //       throw new Error('SSO会員情報取得API実行結果：システムエラー')
    //     case 6000:
    //       popup({
    //         text:
    //           '新しいバージョンがあります。\r\nストアからアプリのバージョンアップをお願いします。',
    //       })
    //       throw new Error('バージョンチェックエラー')
    //     case 6500:
    //       popup({
    //         text:
    //           'お得ナビアプリは「JAFアプリ」に統合されました。\r\nストアから「JAFアプリ」のダウンロードをお願いします。',
    //       })
    //       throw new Error('新アプリ移行対象エラー')
    //   }
    // }
    if (e.response) {
      switch (e.response.status) {
        case 400:
          popup({ text: 'システムエラーが発生しました。(WU99997)' })
          return Promise.reject(e)
        case 500:
        case 503:
        case 504:
          popup({ text: 'システムエラーが発生しました。(WU99998)' })
          return Promise.reject(e)
        case 404:
        case 405:
        case 415:
          popup({ text: 'システムエラーが発生しました。(WU99999)' })
          return Promise.reject(e)
        default:
          popup({ text: 'システムエラーが発生しました。(WU99996)' })
          return Promise.reject(e)
      }
    } else {
      if (e.message === 'Network Error') {
        popup({
          text:
            'ネットワークに接続されていません。通信環境や機内モード設定をご確認の上、お手数ですが、画面上部「JAF」アイコンをタップして再度アクセスしてください。',
        })
        return Promise.reject(e)
      } else if (e.message.includes('timeout')) {
        popup({
          text:
            '現在、アクセスが集中しています。お手数をお掛けしますが、時間をあけてお試しください。(WU99994)',
        })
        return Promise.reject(e)
      } else {
        popup({
          text: 'システムエラーが発生しました。(WU99995)',
        })
        return Promise.reject(e)
      }
    }
  }
)

export default instance
